import { combineReducers } from 'redux';

import loggedin from './loginStatusReducer';

export default combineReducers({
  loggedin
});
